package com.eladfinish.bible.contest.screens.chapterComplete.features.createCompletions

import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.constants.BooleanConstants
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_EACH_VERSE_IN_NEW_LINE
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_ENABLE_LINE_LENGTH_ACCORDING_TO_WORD_LENGTH
import com.eladfinish.bible.contest.screens.chapterComplete.model.UserCompletionsModel
import com.eladfinish.bible.contest.text.SpannableStringKMP

class RenderUserCompletionsUseCase(
    private val settings: KeyValueSettings,
    private val renderer: UserCompletionsRenderer,
) {

    operator fun invoke(
        model: UserCompletionsModel,
    ): SpannableStringKMP {
        val variableLengthUnderline = settings.getBoolean(
            key = KEY_ENABLE_LINE_LENGTH_ACCORDING_TO_WORD_LENGTH,
            defaultValue = true,
        )
        val eachVerseInNewLine = settings.getBoolean(
            key = KEY_EACH_VERSE_IN_NEW_LINE,
            defaultValue = BooleanConstants.ENABLE_EACH_VERSE_IN_NEW_LINE,
        )

        return renderer.render(
            model = model,
            variableLengthUnderline = variableLengthUnderline,
            eachVerseInNewLine = eachVerseInNewLine,
        )
    }
}
